import { useEffect, useState } from "react";
import { Box, Button, Paper, Typography } from "@mui/material";
import locales from "../locales.json";
import { useLang } from "../context/LangContext";
import {
  getGoogleAdsConsent,
  setGoogleAdsConsent,
  syncGoogleAdsConsent,
} from "../utils/googleAds";

function ConsentBanner() {
  const [visible, setVisible] = useState(false);
  const { lang } = useLang();
  const { consent_banner } = locales;

  useEffect(() => {
    const consent = getGoogleAdsConsent();
    if (!consent) {
      setVisible(true);
    } else {
      syncGoogleAdsConsent();
    }
  }, []);

  const handleAccept = () => {
    setGoogleAdsConsent("granted");
    window.dispatchEvent(new Event("google-ads-consent-granted"));
    setVisible(false);
  };

  const handleDecline = () => {
    setGoogleAdsConsent("denied");
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <Box
      sx={{
        position: "fixed",
        left: 16,
        right: 16,
        bottom: 16,
        zIndex: 1400,
        display: "flex",
        justifyContent: "center",
        pointerEvents: "none",
      }}
    >
      <Paper
        elevation={6}
        sx={{
          maxWidth: 680,
          width: "100%",
          px: { xs: 2, sm: 3 },
          py: 2,
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          gap: 2,
          alignItems: { xs: "stretch", sm: "center" },
          justifyContent: "space-between",
          pointerEvents: "auto",
        }}
      >
        <Typography variant="body2" color="text.secondary">
          {consent_banner.message[lang] || consent_banner.message.en}
        </Typography>
        <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
          <Button variant="text" color="inherit" onClick={handleDecline}>
            {consent_banner.decline[lang] || consent_banner.decline.en}
          </Button>
          <Button variant="contained" onClick={handleAccept}>
            {consent_banner.accept[lang] || consent_banner.accept.en}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}

export default ConsentBanner;
